export var SystemModeType;
(function (SystemModeType) {
    SystemModeType["RECOVERY"] = "Recovery Mode";
    SystemModeType["NORMAL"] = "Normal";
})(SystemModeType || (SystemModeType = {}));
export var EcosystemDataType;
(function (EcosystemDataType) {
    EcosystemDataType["balanceOf"] = "balanceOf";
    EcosystemDataType["totalSupply"] = "totalSupply";
})(EcosystemDataType || (EcosystemDataType = {}));
export var TokenType;
(function (TokenType) {
    TokenType["babelfish"] = "babelfish";
    TokenType["mynt"] = "mynt";
})(TokenType || (TokenType = {}));
